// ✅ Importaciones principales de React
import { useRef, useState } from "react";
import SignaturePad from "react-signature-canvas"; 
import { ButtonPopup } from "../../../ui/ButtonPopup";
import { FirmaProps } from "@/types";
import Alerta from "../../../alert/Alerta";
import { EditaDatosProfesionalCss } from '../../../styles';

const Firma: React.FC<FirmaProps> = ({
    onFirmaAccept,
    onSave,
    onClose,
    onAccept,
}) => {

    const sigPadRef = useRef<SignaturePad | null>(null);

    const [alertVisible, setAlertVisible] = useState(false);
    const [isSaving] = useState(false);

    const clear = () => {
        sigPadRef.current?.clear();
        setAlertVisible(false);
    };

    const trim = async () => {
        if (sigPadRef.current?.isEmpty()) {
            setAlertVisible(true);
            return;
        }

        const dataURL = sigPadRef.current!
            .getTrimmedCanvas()
            .toDataURL("image/png");

        // 👉 ENVÍA LA FIRMA BASE64 AL PADRE
        onFirmaAccept?.(dataURL);
        onSave?.(dataURL);

        try {
            onClose?.();
            onAccept?.();
        } catch (err) {
            console.error(err);
        }
    };

    const handleCloseAlert = () => setAlertVisible(false);

    return (
        <div
            className={`flex flex-col w-full items-center p-4 md:p-8 space-y-4 bg-zinc-100 rounded-lg ${EditaDatosProfesionalCss.emergenteTelefono}`}
        >
            <div className="w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl aspect-[2/1] border-t-4 border-t-zinc-600 border-r-2 border-r-zinc-500 border-l-2 border-b-2 border-zinc-400 rounded-lg overflow-hidden">
                <SignaturePad
                    canvasProps={{ className: "w-full h-full" }}
                    ref={sigPadRef}
                    onBegin={() => setAlertVisible(false)}
                />
            </div>

            <div className="flex flex-wrap justify-center space-x-4">
                <ButtonPopup
                    onClick={clear}
                    className="hover:border-red-500 hover:text-red-500 w-24 xs:w-20 sm:w-24 md:w-28 lg:w-32 h-9"
                >
                    Borrar
                </ButtonPopup>

                <ButtonPopup
                    onClick={trim}
                    className="hover:border-blue-500 hover:text-blue-500 w-24 xs:w-20 sm:w-24 md:w-28 lg:w-32 h-9"
                    disabled={isSaving}
                >
                    Aceptar
                </ButtonPopup>
            </div>

            {alertVisible && (
                <Alerta
                    type="noFirma"
                    mensaje="Firma no realizada."
                    onClose={handleCloseAlert}
                    className="w-60 text-center shadow-blue-800 p-4 rounded-lg border-r-2 border-b-2 border-red-900 shadow-md active:bg-white active:text-black text-white flex items-center justify-center"
                />
            )}

            {isSaving && <div className="text-center">Guardando firma...</div>}
        </div>
    );
};

export default Firma;
